module.exports = __webpack_public_path__ + "img/solar_house_pattaya.a32c968a.svg";